import React, { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';

import { ErrorBoundary } from '@ey/mfe-ui-core';
import LeftNavigation from '../components/molecules/LeftNavigation';
import '../config/axiosConfig';
import AppHeader from '../components/molecules/AppHeader';
import GlobalNotification from '../components/molecules/GlobalNotification';

const Loading = () => {
  return (
    <div>Loading...</div>
  );
}
const Header = React.lazy(() => import('map_header/Header'));
const Footer = React.lazy(() => import('map_footer/Footer'));


const RootLayout = () => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  return (
    <>
      <div className="root-layout">
        <AuthenticatedTemplate>
          <ErrorBoundary fallback={<div>Unable to load header</div>}>
            <Suspense fallback={<div>Loading Header...</div>}>
            <div className='hidden'>
              <Header />
            </div>
              <AppHeader setDrawerOpen={setDrawerOpen} drawerOpen={drawerOpen} />
            </Suspense>
          </ErrorBoundary>

          <div className="flex gap-0">
            {drawerOpen && (
              <div className='w-[25%]'>
                <LeftNavigation />
              </div>
            )}
            <div className="w-full">
              <Outlet />
            </div>
          </div>
          <div id="app-footer"></div>
          <ErrorBoundary fallback={<div>Unable to load footer</div>}>
            <Suspense fallback={<div>Loading Footer...</div>}>
              <Footer />
            </Suspense>
          </ErrorBoundary>
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <Loading />
        </UnauthenticatedTemplate>
        <GlobalNotification />
      </div>
    </>
  );
};
export default RootLayout;
